var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vcs-alerts",class:_vm.position,attrs:{"role":"region","aria-label":"alerts"}},_vm._l((this.$root.alerts),function(item){return _c('AlertItem',{key:item.index,attrs:{"title":item.name,"description":item.description,"icon":item.icon}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }